import { useMatches } from 'react-router-dom';

export const SHARE_ROUTE_ID = 'ShareRoute';

export const useIsShareRoute = () => {
  const matches = useMatches();

  return matches.some(route => route.id === SHARE_ROUTE_ID);
};
